import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { PopulateSegmentValuesDrawerService } from './populate-segment-values-drawer.service';

import { PopulateSegmentValuesDrawerComponent } from './populate-segment-values-drawer.component';

@NgModule({
  declarations: [PopulateSegmentValuesDrawerComponent],
  exports: [PopulateSegmentValuesDrawerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    NzDrawerModule,
    NzFormModule,
    NzIconModule,
    NzSpinModule,
    ReactiveFormsModule,
    TtcMatInputModule,
  ],
  providers: [PopulateSegmentValuesDrawerService],
})
export class PopulateSegmentValuesDrawerModule {}
